const isLoggingEnabled =
  process.env.REACT_APP_ENABLE_LOGS === "true" ||
  process.env.NODE_ENV === "development";

export const logger = {
  log: (...args: unknown[]) => {
    if (isLoggingEnabled) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isLoggingEnabled) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    if (isLoggingEnabled) console.error(...args);
  },
};
